import benjyLogo from '../../../../assets/img/benjy-logo.jpg'
import cSosLogo from '../../../../assets/img/corporacion-sos-logo.png'

export const useHelpers = () => {

    const defaultFontSize = 10
    const titleFontSize = 25
    const widthPage = 180
    
    const getCurrentDate = () => {
        const today = new Date(); // Crea un objeto de fecha con la fecha actual
        const year = today.getFullYear(); // Obtiene el año
        const month = today.getMonth() + 1; // Obtiene el mes (getMonth() devuelve un índice basado en cero, por lo que se suma 1)
        const day = today.getDate(); // Obtiene el día del mes
    
        // Formatea la fecha en 'YYYY-MM-DD', asegurándote de agregar un cero delante de meses y días menores a 10
        return `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`;
    }

    const getCurrentTime = () => {
        const now = new Date();

        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');

        return `${hours}:${minutes}`;
    };

    // ::::::::::::::::::::::::::::::::::: Pase de salida
    const _drawEpHeaderDocument = (docPdf, data, posY) => {
        
        // Logo
        const imgBenjyWidth = 55;
        const imgBenjyHeight = 20;
        docPdf.addImage(benjyLogo, 'JPG', 20, posY-13, imgBenjyWidth, imgBenjyHeight);

        // Datos Sistema
        const [year, month, day] = data.info_fecha_ingreso.split('-');
        const fechaIngreso = `${day}-${month}-${year}`;
        docPdf.setFontSize(defaultFontSize);
        docPdf.setFont("helvetica", "normal");
        docPdf.text(`Código: ${data.identificador}`, 140, posY-15, { align: 'left' });
        docPdf.text(`Fecha Ingreso: ${fechaIngreso}`, 140, posY-10, { align: 'left' });
        docPdf.text(`Usuario: ${data.usuario_creo}`, 140, posY-5, { align: 'left' });
        
        posY += 10

        // Fecha de emisión
        docPdf.setFontSize(defaultFontSize);
        docPdf.setFont("helvetica", "normal");
        docPdf.text(`Escuintla, ${data.queryDateInLetters}`, 140, posY, { align: 'left' });
        
        posY += 5

        // Dedicatoria
        docPdf.setFontSize(defaultFontSize);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('PASE DE SALIDA', 110, posY+5, { align: 'center' });

    }
    
    const _drawEpBodyDocument = (docPdf, data, justifyTextBox, posY) => {

        // Saludo
        let parrafoUno = ''
        parrafoUno += 'Se autoriza la salida de las instalaciones de *PREDIO PRIVADO BENJY* por haber completado'
        parrafoUno += `el trámite administrativo de conformidad con el recibo de pago *número ${data.last_idrecibo}* `
        parrafoUno += 'el vehículo con las siguientes características:'
        docPdf.setFontSize(defaultFontSize);
        docPdf.setFont("helvetica", "normal");
        justifyTextBox(docPdf, parrafoUno || '', 20, posY, widthPage, {
            fontSize: defaultFontSize,
            fontName: 'helvetica',
            lineSpacing: 5
        })

        posY += 15

        // info de vehículo
        docPdf.setFontSize(defaultFontSize);
        docPdf.setFont("helvetica", "bold");
        docPdf.text(`TIPO: ${data.tarifa_aplicada}`, 70, posY, { align: 'left' });
        posY += 7
        docPdf.text(`MARCA: ${data.vehicle_marca}`, 70, posY, { align: 'left' });
        posY += 7
        docPdf.text(`LINEA: ${data.vehicle_linea}`, 70, posY, { align: 'left' });
        posY += 7
        docPdf.text(`MODELO: ${data.vehicle_modelo}`, 70, posY, { align: 'left' });
        posY += 7
        docPdf.text(`CHASIS: ${data.vehicle_chasis || '-NO INGRESADO-'}`, 70, posY, { align: 'left' });
        posY += 7
        docPdf.text(`MOTOR: ${data.vehicle_motor || '-NO INGRESADO-'}`, 70, posY, { align: 'left' });
        posY += 7
        docPdf.text(`COLOR: ${data.vehicle_color}`, 70, posY, { align: 'left' });
        posY += 7
        docPdf.text(`PLACA: ${data.vehicle_placa}`, 70, posY, { align: 'left' });
        posY += 7
        docPdf.text(`Y demás datos que constan en la documentación respectiva.`, 50, posY, { align: 'left' });
        
        posY += 10
        docPdf.setFont("helvetica", "normal");
        docPdf.text(`Títular que retira: ${data.titularTextToAdd}`, 20, posY, { align: 'left' });
        docPdf.text(`Nombre: ${data.info_cliente || '-NOMBRE DE CLIENTE NO INGRESADO-'}`, 20, posY+5, { align: 'left' });
        docPdf.text(`DPI/Pasaporte: ${data.info_dpi || '-DPI DE CLIENTE NO INGRESADO-'}`, 20, posY+10, { align: 'left' });
        
        posY += 20
        docPdf.text('Motivo:', 20, posY, { align: 'left' });
        docPdf.text('DEVOLUCIÓN DE VEHÍCULO CONSIGNADO', 20, posY+5, { align: 'left' });
        
        posY += 15
        docPdf.text('Observaciones:', 20, posY, { align: 'left' });
        docPdf.setFontSize(defaultFontSize);
        docPdf.setFont("helvetica", "normal");
        justifyTextBox(docPdf, data.observationsToAdd || '', 20, posY+5, widthPage, {
            fontSize: defaultFontSize,
            fontName: 'helvetica',
            lineSpacing: 7
        })

        
        docPdf.line(20, posY+7, 200, posY+7);
        docPdf.line(20, posY+14, 200, posY+14);
        docPdf.line(20, posY+21, 200, posY+21);

        posY += 30
        docPdf.setFont("helvetica", "bold");
        docPdf.text('RETENER EN GARITA AL MOMENTO DE SALIDA Y REMITIR', 110, posY, { align: 'center' });
        docPdf.text('A ADMINISTRACIÓN PARA SU ARCHIVO', 110, posY+5, { align: 'center' });
        
        posY += 30
        docPdf.text('F.', 65, posY, { align: 'left' });
        docPdf.line(70, posY, 150, posY);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('DEPARTAMENTO ADMINISTRATIVO', 110, posY+5, { align: 'center' })
        docPdf.text(data.user.name, 110, posY+10, { align: 'center' })
        docPdf.text('MANVAR GROUP, SOCIEDAD ANONIMA', 110, posY+15, { align: 'center' })
        docPdf.text('KILOMETRO 59.5 CARRETERA A TAXISCO, ESCUINTLA, ESCUINTLA', 110, posY+20, { align: 'center' })
        docPdf.text('PBX: 2458-1568', 110, posY+25, { align: 'center' })

    }
    
    const _drawEpFooterDocument = (docPdf, data, posY) => {
        
        // posY += 16
        docPdf.setFontSize(8);
        docPdf.setFont("helvetica", "normal");
        docPdf.text(`${data.identificador} :::: ${data.request_id}`, 10, posY, { align: 'left' });

    }

    const drawExitPassDocument = (pdfManager, data) => {
        
        const { pdfPortraitDoc, justifyTextBox } = pdfManager

        // console.log('drawExitPassDocument ----- ', data)

        _drawEpHeaderDocument(pdfPortraitDoc, data, 30)
        _drawEpBodyDocument(pdfPortraitDoc, data, justifyTextBox, 60)
        _drawEpFooterDocument(pdfPortraitDoc, data, 270)

        // pdfPortraitDoc.save(`PASE DE SALIDA PJ${data.idreception} ${data.vehicle_placa}.pdf`);
        // doc.save(`REPORTE ${data.descripcion_corta} ${tipoLabel} ${data.fecha_inicio} A ${data.fecha_fin}.pdf`);
        const docName = `PASE DE SALIDA PJ${data.idreception} ${data.vehicle_placa}.pdf`
        const docBase64 = pdfPortraitDoc.output("datauristring").replace(/;filename=[^;]+/, '')

        return { docName, docBase64 }
    }

    // ::::::::::::::::::::::::::::::::::: Oficio de devolución

    const _drawRcHeaderDocument = (docPdf, data, posY) => {
        
        // Logo
        const imgBenjyWidth = 55;
        const imgBenjyHeight = 20;
        docPdf.addImage(benjyLogo, 'JPG', 20, posY-13, imgBenjyWidth, imgBenjyHeight);
        
        // Datos Ssitema
        const [year, month, day] = data.info_fecha_ingreso.split('-');
        const fechaIngreso = `${day}-${month}-${year}`;
        docPdf.setFontSize(defaultFontSize);
        docPdf.setFont("helvetica", "normal");
        docPdf.text(`Código: ${data.identificador}`, 140, posY-15, { align: 'left' });
        docPdf.text(`Fecha Ingreso: ${fechaIngreso}`, 140, posY-10, { align: 'left' });
        docPdf.text(`Usuario: ${data.usuario_creo}`, 140, posY-5, { align: 'left' });

        posY += 10

        // Fecha de emisión
        docPdf.setFontSize(defaultFontSize);
        docPdf.setFont("helvetica", "normal");
        docPdf.text(`Escuintla, ${data.queryDateInLetters}`, 140, posY+5, { align: 'left' });
        
        posY += 15

        // Dedicatoria
        docPdf.setFontSize(defaultFontSize);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('ACTA DE DEVOLUCIÓN DE VEHÍCULO CONSIGNADO', 110, posY+5, { align: 'center' });

    }
    
    const _drawRcBodyDocument = (docPdf, data, justifyTextBox, posY) => {
        
        // Saludo
        const textSaludo = `En la fecha y hora indicada, *PREDIO PRIVADO BENJY* procede a la devolución del vehículo consignado a favor de *${data.info_cliente || '-NO INGRESADO-'}*, quien se identifica con Documento Personal de Identificación -DPI- Código Único de Identificación -CUI- Número *${data.info_dpi || '-NO INGRESADO-'}*, con las siguientes características:`
        docPdf.setFontSize(defaultFontSize);
        docPdf.setFont("helvetica", "normal");
        justifyTextBox(docPdf, textSaludo || '', 20, posY, widthPage, {
            fontSize: defaultFontSize,
            fontName: 'helvetica',
            lineSpacing: 5
        })
        
        posY += 20

        // info de vehículo
        docPdf.setFontSize(defaultFontSize);
        docPdf.setFont("helvetica", "bold");
        docPdf.text(`TIPO: ${data.tarifa_aplicada}`, 70, posY, { align: 'left' });
        posY += 7
        docPdf.text(`MARCA: ${data.vehicle_marca}`, 70, posY, { align: 'left' });
        posY += 7
        docPdf.text(`LINEA: ${data.vehicle_linea}`, 70, posY, { align: 'left' });
        posY += 7
        docPdf.text(`MODELO: ${data.vehicle_modelo}`, 70, posY, { align: 'left' });
        posY += 7
        docPdf.text(`CHASIS: ${data.vehicle_chasis || '-NO INGRESADO-'}`, 70, posY, { align: 'left' });
        posY += 7
        docPdf.text(`MOTOR: ${data.vehicle_motor || '-NO INGRESADO-'}`, 70, posY, { align: 'left' });
        posY += 7
        docPdf.text(`COLOR: ${data.vehicle_color}`, 70, posY, { align: 'left' });
        posY += 7
        docPdf.text(`PLACA: ${data.vehicle_placa}`, 70, posY, { align: 'left' });
        posY += 7
        docPdf.text(`Y demás datos que constan en la documentación respectiva.`, 50, posY, { align: 'left' });
        
        posY += 10
        let textContent = ''

        // PRIMERO --------------
        textContent += '*PRIMERO:* La devolución se efectúa con base a la documentación presentada por el solicitante en donde consta una '
        textContent += `orden emitida por *${data.nameToReturnToAdd.toUpperCase()}*.Dichos documentos demuestran que *EL SOLICITANTE* ha realizado `
        textContent += 'todas y cada una de las diligencias de conformidad con la ley, siendo el único responsable de dicha gestión, sin que '
        textContent += 'que *PREDIO PRIVADO BENJY* haya emitido pronunciamiento alguno sobre la legalidad, autenticidad o validez de dicha documentación.\n'
        // SEGUNDO --------------
        textContent += '*SEGUNDO:* Previo a la firma de la presente acta, se le advierte al solicitante que, en caso de existir alguna inconformidad, '
        textContent += 'deberá presentar la denuncia respectiva ante autoridad competente antes de retirar el vehículo, para así poder solventar '
        textContent += 'cualquier situación relacionada con el mismo, sin embargo, el solicitante manifiesta haber tenido la oportunidad de inspeccionar '
        textContent += 'físicamente el vehículo, así como la documentación y registros relacionados con su ingreso a nuestras instalaciones.\n'
        // TERCERO --------------
        textContent += '*TERCERO:* El solicitante declara que recibe el vehículo anteriormente descrito en el estado físico que se encuentra al'
        textContent += 'momento de su entrega, luego de haber realizado la inspección correspondiente manifestando su entera satisfacción.'
        // CUARTO --------------
        textContent += '*CUARTO:* Una vez retirado el vehículo de las instalaciones de *PREDIO PRIVADO BENJY*, el solicitante asume toda '
        textContent += 'responsabilidad relacionada con su posesión, custodia, traslado, uso y destino posterior.\n'
        // QUINTO --------------
        textContent += '*QUINTO:* El solicitante en el presente acto, extiende el más amplio y eficaz *FINIQUITO* a favor de '
        textContent += '*PREDIO PRIVADO BENJY,* sus propietarios, accionistas, representantes legales, trabajadores y colaboradores '
        textContent += 'o cualquier persona relacionada, por cualquier situación con la consignación, custodia, documentación y '
        textContent += 'devolución del vehículo objeto de la presente acta, por lo que para efectos legales, señala lugar para recibir '
        textContent += `citaciones, notificaciones o emplazamientos, la siguiente dirección *${data.addressToAdd}* y el número telefónico *${data.phoneToAdd}*.\n`

        docPdf.setFontSize(defaultFontSize);
        docPdf.setFont("helvetica", "normal");
        justifyTextBox(docPdf, textContent || '', 20, posY, widthPage, {
            fontSize: defaultFontSize,
            fontName: 'helvetica',
            lineSpacing: 5
        })
        
        // posY += 25
        // let textSegundo = ''
        // textSegundo += '*SEGUNDO:* Previo a la firma de la presente acta, se le advierte al solicitante que, en caso de existir alguna inconformidad, '
        // textSegundo += 'deberá presentar la denuncia respectiva ante autoridad competente antes de retirar el vehículo, para así poder solventar '
        // textSegundo += 'cualquier situación relacionada con el mismo, sin embargo, el solicitante manifiesta haber tenido la oportunidad de inspeccionar '
        // textSegundo += 'físicamente el vehículo, así como la documentación y registros relacionados con su ingreso a nuestras instalaciones.'
        // docPdf.setFontSize(defaultFontSize);
        // docPdf.setFont("helvetica", "normal");
        // justifyTextBox(docPdf, textSegundo || '', 20, posY, widthPage, {
        //     fontSize: defaultFontSize,
        //     fontName: 'helvetica',
        //     lineSpacing: 5
        // })
        
        // posY += 25
        // let textTercero = ''
        // textTercero += '*TERCERO:* El solicitante declara que recibe el vehículo anteriormente descrito en el estado físico que se encuentra al'
        // textTercero += 'momento de su entrega, luego de haber realizado la inspección correspondiente manifestando su entera satisfacción.'
        // docPdf.setFontSize(defaultFontSize);
        // docPdf.setFont("helvetica", "normal");
        // justifyTextBox(docPdf, textTercero || '', 20, posY, widthPage, {
        //     fontSize: defaultFontSize,
        //     fontName: 'helvetica',
        //     lineSpacing: 5
        // })
        
        // posY += 15
        // let textCuarto = ''
        // textCuarto += '*CUARTO:* Una vez retirado el vehículo de las instalaciones de *PREDIO PRIVADO BENJY*, el solicitante asume toda '
        // textCuarto += 'responsabilidad relacionada con su posesión, custodia, traslado, uso y destino posterior.'
        // docPdf.setFontSize(defaultFontSize);
        // docPdf.setFont("helvetica", "normal");
        // justifyTextBox(docPdf, textCuarto || '', 20, posY, widthPage, {
        //     fontSize: defaultFontSize,
        //     fontName: 'helvetica',
        //     lineSpacing: 5
        // })

        // posY += 10
        // let textQuinto = ''
        // textQuinto += '*QUINTO:* El solicitante en el presente acto, extiende el más amplio y eficaz *FINIQUITO* a favor de '
        // textQuinto += '*PREDIO PRIVADO BENJY,* sus propietarios, accionistas, representantes legales, trabajadores y colaboradores '
        // textQuinto += 'o cualquier persona relacionada, por cualquier situación con la consignación, custodia, documentación y '
        // textQuinto += 'devolución del vehículo objeto de la presente acta, por lo que para efectos legales, señala lugar para recibir '
        // textQuinto += `citaciones, notificaciones o emplazamientos, la siguiente dirección *${data.addressToAdd}* y el número telefónico *${data.phoneToAdd}*.`
        // docPdf.setFontSize(defaultFontSize);
        // docPdf.setFont("helvetica", "normal");
        // justifyTextBox(docPdf, textQuinto || '', 20, posY, widthPage, {
        //     fontSize: defaultFontSize,
        //     fontName: 'helvetica',
        //     lineSpacing: 5
        // })

    }
    
    const _drawRcFooterDocument = (docPdf, data, justifyTextBox, posY) => {
        
        const textFooter = 'Y para dejar constancia, firma la presente acta en el mismo lugar y fecha indicados.'
        docPdf.setFontSize(defaultFontSize);
        docPdf.setFont("helvetica", "normal");
        // docPdf.text(textFooter, 20, posY, { align: 'left' });
        justifyTextBox(docPdf, textFooter || '', 20, posY, widthPage, {
            fontSize: defaultFontSize,
            fontName: 'helvetica',
            lineSpacing: 5
        })
        
        posY += 30

        // Firma
        docPdf.text('F.', 65, posY, { align: 'left' });
        docPdf.line(70, posY, 150, posY);
        docPdf.setFont("helvetica", "bold");
        docPdf.text(data.info_cliente, 73, posY+5, { align: 'left' });
        docPdf.setFont("helvetica", "bold");
        docPdf.text(data.info_cliente || '-NOMBRE DE CLIENTE NO INGRESADO-', 110, posY+10, { align: 'center' });
        docPdf.text(data.info_dpi || '-DPI DE CLIENTE NO INGRESADO-', 110, posY+15, { align: 'center' });

        posY += 50
        docPdf.setFontSize(8);
        docPdf.setFont("helvetica", "normal");
        docPdf.text(`${data.identificador} :::: ${data.request_id}`, 10, posY, { align: 'left' });

    }

    const drawReturnCertificateDocument = (pdfManager, data) => {
        
        const { pdfPortraitLegalDoc, justifyTextBox } = pdfManager

        // console.log('drawExitPassDocument ----- ', data)

        _drawRcHeaderDocument(pdfPortraitLegalDoc, data, 30)
        _drawRcBodyDocument(pdfPortraitLegalDoc, data, justifyTextBox, 70)
        _drawRcFooterDocument(pdfPortraitLegalDoc, data, justifyTextBox, 270)

        // pdfPortraitLegalDoc.save(`OFICIO DE DEVOLUCIÓN PJ${data.idreception} ${data.vehicle_placa}.pdf`);
        const docName = `OFICIO DE DEVOLUCIÓN PJ${data.idreception} ${data.vehicle_placa}.pdf`
        const docBase64 = pdfPortraitLegalDoc.output("datauristring").replace(/;filename=[^;]+/, '')

        return { docName, docBase64 }
    }
    
    return Object.freeze({
        getCurrentDate,
        getCurrentTime,
        drawExitPassDocument,
        drawReturnCertificateDocument
    })
}